import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: 16,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    lineHeight: 1,
  },
  scheduleTitle: {
    lineHeight: 1,
  },
  scheduleSubtitle: {
    lineHeight: 1.5,
    fontWeight: 500,
  },
  avatar: {
    width: 100,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  scheduleBtn: {
    all: 'unset',
    color: '#2d86ca',
    cursor: 'pointer',
  },
}));
